import { deviceOS, routeConstants } from "@utils/constants";
import { checkSegments } from "./util";
import { isEmailWinback } from "./email";
import { isUS } from "./locale";
import { CoreReduxState } from "../redux/store";
import { getMeristemContext } from "../meristemContext";

export interface SegmentFunction {
  (state?: CoreReduxState): boolean;
  load?: (store?: CoreReduxState) => Promise<void>;
}

// Baseline/control routes
export const isCore = checkSegments({
  oneOf: [
    routeConstants.exsf01,
    routeConstants.exsf01d,
    routeConstants.awsem,
    routeConstants.direct,
  ],
});
export const isAffiliateWithoutTrial = checkSegments({
  oneOf: [
    routeConstants.affiliateNoTrial,
    routeConstants.affiliateNoTrialPromo,
  ],
});
export const isBaseline = checkSegments({
  oneOf: [isCore, isAffiliateWithoutTrial],
});

export const isCoreDirect = checkSegments({
  oneOf: [routeConstants.direct, routeConstants.baseline],
});

export const isDirect = checkSegments({
  oneOf: [routeConstants.direct],
});

export const isCorePaid = checkSegments({
  oneOf: [routeConstants.exsf01, routeConstants.exsf01d, routeConstants.awsem],
});
export const isAdWordsSEM = checkSegments({
  oneOf: [routeConstants.awsem],
});
export const isUSAdWordsSEM = checkSegments({
  allOf: [isUS],
  oneOf: [isAdWordsSEM],
});

export const isWinback = checkSegments({
  oneOf: [routeConstants.winback],
});
export const isWebWinback = checkSegments({
  oneOf: [isEmailWinback, isWinback],
});

export const isHM = checkSegments({
  oneOf: [
    routeConstants.hmDirect,
    routeConstants.hmExsf01,
    routeConstants.hmExsf01d,
    routeConstants.hmPaid,
    routeConstants.hmAwsem,
  ],
});

export const isPreSignup = () =>
  [
    "landing",
    "main-survey",
    "payment",
    "payment-survey",
    "payment-checkout",
  ].includes(getMeristemContext().context_type);

export * from "./locale";
export * from "./demographics";
export * from "./email";
export * from "./in-app";

export const isMobile = () => {
  return !!getMeristemContext().device_is_mobile;
};

export const isIOS = () => {
  return getMeristemContext().device_os === deviceOS.iOS;
};

// Old style

/**
 * Verifies if current user is on main routes and is from US language
 */
export const isUSBaseline = checkSegments({
  allOf: [isUS],
  oneOf: [isBaseline],
});

/**
 * Verifies if current user is on winback route and is from US
 */
export const isUSWinback = checkSegments({
  allOf: [isUS],
  oneOf: [isWinback],
});

/**
 * Verifies if current user is on (winback or baseline/main routes) and is from US
 */
export const isUSBaselineOrWinback = checkSegments({
  allOf: [isUS],
  oneOf: [isBaseline, isWinback],
});

/**
 * Verifies if current user is on (core-winback or baseline/main routes) and is from US
 */
export const isUSBaselineOrCoreWinback = checkSegments({
  allOf: [isUS],
  oneOf: [isBaseline, isWebWinback],
});

/**
 * Verifies if current user is on core routes in US
 */
export const isUsCore = () => {
  return isCore() && isUS();
};

/**
 * Verifies if current user is on main routes and with EN language and not US
 */
export const isIntlBaseline = () => {
  return isBaseline() && !isUS();
};
